import { render, staticRenderFns } from "./viewLog.vue?vue&type=template&id=673dedf3&scoped=true"
import script from "./viewLog.vue?vue&type=script&lang=js"
export * from "./viewLog.vue?vue&type=script&lang=js"
import style0 from "./viewLog.vue?vue&type=style&index=0&id=673dedf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dedf3",
  null
  
)

export default component.exports